export default "__VITE_ASSET__B51_m1Fp__"